import { render, staticRenderFns } from "./CurrentOrderButton.vue?vue&type=template&id=3d023d3d&"
import script from "./CurrentOrderButton.vue?vue&type=script&lang=js&"
export * from "./CurrentOrderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports